import React, { useEffect, useState } from "react";
import classes from "./Catalog.module.css"
import Product from "../../../Product/Product";
import АМР_4753_10 from "../../../../img/АМР_4753-10.png"
import АМР_4753_102 from "../../../../img/АМР_4753-102.png"
import АМР_4753_103 from "../../../../img/АМР_4753-103.png"
import АМР_4753_20 from "../../../../img/АМР_4753-20.png"
import АМР_4753_30 from "../../../../img/АМР_4753-30.png"
import АМР_4753_40 from "../../../../img/АМР_4753-40.png"
import arrow from "../../../../img/arrow.png"

const Catalog = () => {

    let [visibility, setVisibility] = useState(0);
    const [transforming, setTransforming] = useState("0")
    const [visibilityMax, setVisibilityMax] = useState(2)
    const [visibilityArrows, setVisibilityArrows] = useState("none")

    useEffect(() => {
        if (window.innerWidth <= 1397 && window.innerWidth >= 1096) {
            setVisibilityMax(3)
        } else if (window.innerWidth <= 1096 && window.innerWidth >= 729) {
            setVisibilityMax(4)
        } else if (window.innerWidth <= 729) {
            setVisibilityMax(5)
        }
    }, [window.innerWidth])

    const transformingL = () => {
        setVisibility(visibility - 1)
        setTransforming(transforming + 300)
    }
    const transforminR = () => {
        setVisibility(visibility + 1)
        setTransforming(transforming - 300)
    }

    return (
        <div className={classes.catalogBlock}>
            <div onMouseOver={()=>{setVisibilityArrows("flex")}} onMouseLeave={()=>{setVisibilityArrows("none")}} className={classes.catalog}>
                <div className={classes.exContent}>
                    <div className={classes.text}>
                        <h2>Преобразователи давления</h2>
                        <h1>Каталог</h1>
                    </div>
                    <div className={classes.arrows}>
                        <div onClick={()=>{visibility > 0 ? transformingL() : setVisibility(visibility)}} id="arrow1" className={classes.arrow1}><img src={arrow} alt="влево" /></div>
                        <div onClick={()=>{visibility < visibilityMax ? transforminR() : setVisibility(visibility)}} id="arrow2" className={classes.arrow2}><img src={arrow} alt="вправо" /></div>
                    </div>
                </div>
                <div className={classes.arrowsContentProd} style={{display: visibilityArrows}}  onMouseOver={()=>{setVisibilityArrows("flex")}}>
                        <div onClick={()=>{visibility > 0 ? transformingL() : setVisibility(visibility)}} id="arrow1" className={classes.arrow1}><img src={arrow} alt="влево" /></div>
                        <div onClick={()=>{visibility < visibilityMax ? transforminR() : setVisibility(visibility)}} id="arrow2" className={classes.arrow2}><img src={arrow} alt="вправо" /></div>
                    </div>
                <div className={classes.contentProduct} style={{transform: `translateX(${transforming}px)`}}>
                    <Product 
                        visible = "1"
                        imgSrc={АМР_4753_10} 
                        imgAlt="АМР 4753-10" 
                        text="АМР 4753-10" 
                        exText=""
                    />
                    <Product 
                        visible = "1"
                        imgSrc={АМР_4753_103} 
                        imgAlt="АМР 4753-10" 
                        text="АМР 4753-10" 
                        exText="Искробезопасное"
                    />
                    <Product 
                        visible = "1"
                        imgSrc={АМР_4753_102} 
                        imgAlt="АМР 4753-10" 
                        text="АМР 4753-10" 
                        exText="Взрывозащищенное"
                    />
                    <Product 
                        visible = "1"
                        imgSrc={АМР_4753_20} 
                        imgAlt="АМР 4753-20" 
                        text="АМР 4753-20" 
                        exText=""
                    />
                    <Product 
                        visible = "1"
                        imgSrc={АМР_4753_30} 
                        imgAlt="АМР 4753-30" 
                        text="АМР 4753-30" 
                        exText=""
                    />
                    <Product 
                        visible = "1"
                        imgSrc={АМР_4753_40} 
                        imgAlt="АМР 4753-40" 
                        text="АМР 4753-40" 
                        exText=""
                    />
                </div>
            </div>
        </div>
    )
}


export default Catalog




// const [data, setData] = useState({})

// useEffect(() => {
//     try {
//         fetch("http://localhost:8000/api/catalog", {
//             method: "GET",
//             headers: { 'Content-Type': 'application/json' },
//         })
//         .then(response=>response.json())
//         .then((response) => {
//             var elemResp = []
//             response.map((e) => {
//                 console.log(e)
//                 const idE = e.id
//                 const idPrE = e.id_paraments
//                 const paramDescr = e.param_descr
//                 elemResp.push({idE, idPrE, paramDescr})
//                 setData(elemResp)
//             })
//             console.log(elemResp)
//         })
//     } catch(e) {
//         console.log(e)
//     }
// }, [])





// {(data[2]) ? data.map((e)=>{
//     const АМР_4753_ = ""
//     const imgData = АМР_4753_ + e.idPrE.split("-")[1]

//     if(e.idPrE === "4753-10") {
//         return <>
//             <Product
//                 text={e.idPrE}
//                 visible = {visibility >= data.indexOf(e)+1 ? "0" : "1"}
//             /> 
//             <Product
//                 text={e.idPrE}
//                 img={imgData}
//                 visible = {visibility >= data.indexOf(e)+2 ? "0" : "1"}
//             />
//             <Product
//                 text={e.idPrE}
//                 visible = {visibility >= data.indexOf(e)+3 ? "0" : "1"}
//             /></>
//     }
//     // console.log(visibility >= data.indexOf(e)+1 ? `${data.indexOf(e)+1} ${visibility}` : "да")
//     return <Product
//         text={e.idPrE}
//         visible = {visibility >= data.indexOf(e)+1 ? "0" : "1"}
//     />
// }) : "Сервер не отпарвил данные"}